/**
 * Help Desk Constants - Single source of truth for areas
 * Matches backend TicketArea enum
 */

// Valid areas within TI department (must match backend TicketArea enum)
export const AREAS = [
  { value: 'Sistemas', label: 'Sistemas' },
  { value: 'Infraestructura', label: 'Infraestructura' },
  { value: 'Soporte Técnico', label: 'Soporte Técnico' },
  { value: 'Capacitaciones', label: 'Capacitaciones' },
  { value: 'Externo', label: 'Externo' },
];

// Legacy value mapping for backward compatibility
export const AREA_LEGACY_MAP = {
  'Software': 'Sistemas',
  'Sistema': 'Sistemas',
  'Soporte técnico': 'Soporte Técnico',
  'TI': 'Sistemas',
};

/**
 * Normalize an area value, mapping legacy values to new ones.
 * @param {string} value - The area value to normalize
 * @returns {string} - The normalized area value
 */
export function normalizeArea(value) {
  if (!value) return value;
  
  // Check legacy map first
  if (AREA_LEGACY_MAP[value]) {
    return AREA_LEGACY_MAP[value];
  }
  
  // Return as-is if it's a valid current area
  const validValues = AREAS.map(a => a.value);
  if (validValues.includes(value)) {
    return value;
  }
  
  // Return as-is if unknown
  return value;
}

/**
 * Check if an area value is valid.
 * @param {string} value - The area value to check
 * @returns {boolean} - True if valid
 */
export function isValidArea(value) {
  const normalized = normalizeArea(value);
  return AREAS.some(a => a.value === normalized);
}

// Area colors for badges
export const AREA_COLORS = {
  'Sistemas': 'bg-blue-100 text-blue-700 border-blue-300',
  'Infraestructura': 'bg-emerald-100 text-emerald-700 border-emerald-300',
  'Soporte Técnico': 'bg-amber-100 text-amber-700 border-amber-300',
  'Capacitaciones': 'bg-purple-100 text-purple-700 border-purple-300',
  'Externo': 'bg-slate-100 text-slate-700 border-slate-300',
};

/**
 * Get the color classes for an area badge.
 * @param {string} value - The area value
 * @returns {string} - Tailwind CSS classes for the badge
 */
export function getAreaColor(value) {
  const normalized = normalizeArea(value);
  return AREA_COLORS[normalized] || 'bg-slate-100 text-slate-700 border-slate-300';
}

// Legacy exports for backward compatibility (deprecated)
export const CLASSIFICATIONS = AREAS;
export const LEGACY_CLASSIFICATION_MAP = AREA_LEGACY_MAP;
export const normalizeClassification = normalizeArea;
export const isValidClassification = isValidArea;
export const CLASSIFICATION_COLORS = AREA_COLORS;
export const getClassificationColor = getAreaColor;
